"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inspectApiResponseData = exports.updateDatabase = exports.getLastUpdatedTimestamp = exports.deleteDataFromDynamoDB = exports.putDataToDynamoDB = exports.getItemByAddress = exports.getItemByPoolNameAndAddress = exports.getItemsByPoolName = void 0;
exports.updateTimestamp = updateTimestamp;
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const decimal_js_1 = require("decimal.js");
const dynamoDBClient_1 = require("../dynamoDBClient");
const HOLDERS_MAIN_TABLE_NAME = process.env.HOLDERS_MAIN_TABLE_NAME;
const HOLDER_CONF_TABLE_NAME = process.env.HOLDERS_CONF_TABLE_NAME;
// Initialize client
const client = (0, dynamoDBClient_1.getDynamoDBClient)();
const getItemsByPoolName = async (poolName, tableName, ddbClient) => {
    const mainTableName = tableName ? tableName : HOLDERS_MAIN_TABLE_NAME;
    const thisClient = ddbClient ? ddbClient : client;
    const command = new client_dynamodb_1.QueryCommand({
        TableName: mainTableName,
        KeyConditionExpression: "poolName = :poolName", // Partition key condition
        ExpressionAttributeValues: {
            ":poolName": { S: poolName },
        },
    });
    try {
        const response = await thisClient.send(command);
        return response.Items;
    }
    catch (error) {
        console.error("Error fetching items by PoolName:", error);
        throw error;
    }
};
exports.getItemsByPoolName = getItemsByPoolName;
const getItemByPoolNameAndAddress = async (poolName, address, tableName, ddbClient) => {
    const mainTableName = tableName ? tableName : HOLDERS_MAIN_TABLE_NAME;
    const thisClient = ddbClient ? ddbClient : client;
    const command = new client_dynamodb_1.QueryCommand({
        TableName: mainTableName,
        KeyConditionExpression: "poolName = :poolName AND address = :address", // Partition and Sort key condition
        ExpressionAttributeValues: {
            ":poolName": { S: poolName },
            ":address": { S: address },
        },
    });
    try {
        const response = await thisClient.send(command);
        if (response && response.Items && response.Items.length > 0) {
            return response.Items[0];
        }
        else {
            console.log("No matching item found");
            return null;
        }
    }
    catch (error) {
        console.error("Error fetching item by PoolName and address:", error);
        throw error;
    }
};
exports.getItemByPoolNameAndAddress = getItemByPoolNameAndAddress;
const getItemByAddress = async (address, tableName, ddbClient) => {
    const mainTableName = tableName ? tableName : HOLDERS_MAIN_TABLE_NAME;
    if (!mainTableName)
        throw new Error("mainTableName not found");
    const thisClient = ddbClient ? ddbClient : client;
    const poolNames = Object.keys(alphafi_sdk_1.poolInfo);
    const keys = poolNames.map((poolName) => ({
        poolName: { S: poolName },
        address: { S: address },
    }));
    const requestParams = {
        RequestItems: {
            [mainTableName]: {
                Keys: keys,
            },
        },
    };
    try {
        const response = await thisClient.send(new client_dynamodb_1.BatchGetItemCommand(requestParams));
        const holdings = response.Responses?.[mainTableName];
        return holdings;
    }
    catch (err) {
        console.error("Error querying user:", err);
    }
};
exports.getItemByAddress = getItemByAddress;
const putDataToDynamoDB = async (poolName, items, tableName, ddbClient) => {
    const mainTableName = tableName ? tableName : HOLDERS_MAIN_TABLE_NAME;
    const thisClient = ddbClient ? ddbClient : client;
    // const batches = [];
    let inputItemsLength = 0;
    while (items.length > 0) {
        // DynamoDB BatchWrite supports a max of 25 items per batch
        const batch = items.splice(0, 25);
        inputItemsLength += batch.length;
        // Ensure each PutRequest is defined and matches the structure
        const requestItems = {
            [mainTableName]: batch.map((holder) => ({
                PutRequest: {
                    Item: {
                        poolName: { S: poolName }, // Partition key
                        address: { S: holder.address }, // Sort key
                        xTokenBalance: { N: holder.xTokenBalance.toString() }, // Numeric balance
                    },
                },
            })),
        };
        const params = {
            RequestItems: requestItems,
            ReturnConsumedCapacity: "TOTAL",
            ReturnItemCollectionMetrics: "SIZE",
        };
        try {
            let unprocessedItems = undefined;
            // Retry unprocessed items until all are processed
            do {
                const response = await thisClient.send(new client_dynamodb_1.BatchWriteItemCommand(params));
                // Log the consumed capacity for this batch
                if (response.ConsumedCapacity) {
                    console.log(`Consumed capacity for this batch: ${JSON.stringify(response.ConsumedCapacity)}`);
                }
                // Check if there are any unprocessed items
                unprocessedItems = response.UnprocessedItems;
                if (unprocessedItems && Object.keys(unprocessedItems).length > 0) {
                    console.log("Retrying unprocessed items...", unprocessedItems);
                    params.RequestItems = unprocessedItems; // Reassign unprocessed items to retry
                }
            } while (unprocessedItems && Object.keys(unprocessedItems).length > 0);
            // batches.push(response); // Keep track of successful responses
        }
        catch (err) {
            console.error(`Error in BatchWriteItemCommand for ${poolName}:`, err);
        }
    }
    console.log(`${inputItemsLength} to be put for pool ${poolName}`);
};
exports.putDataToDynamoDB = putDataToDynamoDB;
const deleteDataFromDynamoDB = async (items, // Assuming poolName is a string
tableName, ddbClient) => {
    const mainTableName = tableName ? tableName : HOLDERS_MAIN_TABLE_NAME;
    const thisClient = ddbClient ? ddbClient : client;
    let inputItemsLength = 0;
    while (items.length > 0) {
        // DynamoDB BatchWrite supports a max of 25 items per batch
        const batch = items.splice(0, 25);
        inputItemsLength += batch.length;
        // Prepare DeleteRequest for each item
        const requestItems = {
            [mainTableName]: batch.map((item) => ({
                DeleteRequest: {
                    Key: {
                        poolName: { S: item.poolName }, // Partition key
                        address: { S: item.address }, // Sort key
                    },
                },
            })),
        };
        const params = {
            RequestItems: requestItems,
            ReturnConsumedCapacity: "TOTAL",
            ReturnItemCollectionMetrics: "SIZE",
        };
        try {
            let unprocessedItems = undefined;
            // Retry unprocessed items until all are processed
            do {
                const response = await thisClient.send(new client_dynamodb_1.BatchWriteItemCommand(params));
                // Log the consumed capacity for this batch
                if (response.ConsumedCapacity) {
                    console.log(`Consumed capacity for this batch: ${JSON.stringify(response.ConsumedCapacity)}`);
                }
                // Check if there are any unprocessed items
                unprocessedItems = response.UnprocessedItems;
                if (unprocessedItems && Object.keys(unprocessedItems).length > 0) {
                    console.log("Retrying unprocessed items...", unprocessedItems);
                    params.RequestItems = unprocessedItems; // Reassign unprocessed items to retry
                }
            } while (unprocessedItems && Object.keys(unprocessedItems).length > 0);
        }
        catch (err) {
            console.error(`Error in BatchWriteItemCommand for pool:`, err);
        }
    }
    console.log(`${inputItemsLength} items deleted from table for all pools`);
};
exports.deleteDataFromDynamoDB = deleteDataFromDynamoDB;
async function updateTimestamp(timestamp, tableName, ddbClient) {
    const confTableName = tableName ? tableName : HOLDER_CONF_TABLE_NAME;
    const thisClient = ddbClient ? ddbClient : client;
    const currentTimestamp = timestamp
        ? timestamp.toString()
        : new Date().getTime().toString(); // Get current timestamp
    const command = new client_dynamodb_1.PutItemCommand({
        TableName: confTableName,
        Item: {
            id: { S: "lastUpdated" }, // A single item with a fixed "id"
            timestamp: { S: currentTimestamp }, // Storing timestamp as a string
        },
    });
    try {
        const response = await thisClient.send(command);
        console.log("Timestamp updated successfully:", response);
        return response;
    }
    catch (error) {
        console.error("Error updating timestamp:", error);
        throw new Error("Failed to update timestamp"); // Return proper Error object
    }
}
const getLastUpdatedTimestamp = async (tableName, ddbClient) => {
    const thisClient = ddbClient ? ddbClient : client;
    const confTableName = tableName ? tableName : HOLDER_CONF_TABLE_NAME;
    const command = new client_dynamodb_1.GetItemCommand({
        TableName: confTableName,
        Key: {
            id: { S: "lastUpdated" }, // The same id used when storing the timestamp
        },
    });
    try {
        const response = await thisClient.send(command);
        return response.Item?.timestamp.S;
    }
    catch (error) {
        console.error("Error retrieving timestamp:", error);
    }
};
exports.getLastUpdatedTimestamp = getLastUpdatedTimestamp;
// TODO:
// Update the timestamp only when other has been success
const updateDatabase = async (mainTableName, confTableName, ddbClient) => {
    const thisMainTableName = mainTableName
        ? mainTableName
        : HOLDERS_MAIN_TABLE_NAME;
    const thisConfTableName = confTableName
        ? confTableName
        : HOLDER_CONF_TABLE_NAME;
    const thisClient = ddbClient ? ddbClient : client;
    // Get the last updated timestamp
    const lastUpdatedTimestamp = await (0, exports.getLastUpdatedTimestamp)(thisConfTableName, thisClient);
    if (!lastUpdatedTimestamp) {
        throw new Error("No last updated timestamp found");
    }
    const currentTimestamp = Date.now();
    // 1. Fetch events from last update until now
    const liquidityChangeEvents = await (0, alphafi_sdk_1.fetchLiquidityChangeEvents)({
        startTime: Number(lastUpdatedTimestamp),
        endTime: currentTimestamp,
    });
    const withdrawV2Events = await (0, alphafi_sdk_1.fetchWithdrawV2Events)({
        startTime: Number(lastUpdatedTimestamp),
        endTime: currentTimestamp,
    });
    // 2. Merge and sort events chronologically (oldest first for ascending order)
    const allEvents = [...liquidityChangeEvents, ...withdrawV2Events].sort((a, b) => a.timestamp - b.timestamp);
    // 3. Process events to determine final states for each user+pool combination
    const userPoolStates = new Map();
    // Process events in ascending order (oldest first)
    // Each new event for a user+pool pair updates its state
    for (const event of allEvents) {
        const address = event.sender;
        const poolId = event.pool_id;
        const poolName = alphafi_sdk_1.poolIdPoolNameMap[poolId];
        if (!poolName) {
            console.warn(`Unknown pool ID: ${poolId} - skipping event`);
            continue;
        }
        // Using address#poolName as the key
        const key = `${address}#${poolName}`;
        const xTokenBalance = event.user_total_x_token_balance;
        // Update the state for this user+pool
        userPoolStates.set(key, {
            address,
            poolName: poolName,
            xTokenBalance,
        });
    }
    // 4. Prepare items to update (including those with zero balances)
    const poolGroups = new Map();
    for (const state of userPoolStates.values()) {
        if (!poolGroups.has(state.poolName)) {
            poolGroups.set(state.poolName, []);
        }
        poolGroups.get(state.poolName).push({
            address: state.address,
            xTokenBalance: state.xTokenBalance,
        });
    }
    // 5. Update the database
    const promises = [];
    // Add/update items in database (grouped by pool)
    for (const [poolName, items] of poolGroups.entries()) {
        promises.push((0, exports.putDataToDynamoDB)(poolName, items, thisMainTableName, thisClient));
    }
    // Wait for all database operations to complete
    await Promise.all(promises);
    await updateTimestamp(currentTimestamp, thisConfTableName, thisClient);
};
exports.updateDatabase = updateDatabase;
const inspectApiResponseData = (data) => {
    let total = new decimal_js_1.Decimal(0);
    data.holders.map((o) => {
        total = total.add(new decimal_js_1.Decimal(o.xTokenBalance));
    });
    console.log(data.holders.length, total);
    if (total.equals(new decimal_js_1.Decimal(data.xTokenSupply))) {
        console.log("total is equal to supply");
    }
    else {
        console.log("total off to supply by", new decimal_js_1.Decimal(data.xTokenSupply).sub(total));
    }
};
exports.inspectApiResponseData = inspectApiResponseData;
//aws dynamodb scan --table-name Alphafi-holders --endpoint-url http://localhost:8000
//aws dynamodb scan --table-name Alphafi-holders --endpoint-url http://localhost:8000 > output.json
//aws dynamodb list-tables --endpoint-url http://localhost:8000
//aws dynamodb delete-table --table-name Alphafi-holders --endpoint-url http://localhost:8000
//java -Djava.library.path=./DynamoDBLocal_lib -jar DynamoDBLocal.jar -sharedDb
// shift above functions to sui-alpha-sdk
// read tableName from env
// make changes for above functions in alphafi-crons and here too
//# sourceMappingURL=index.js.map